<template>

  <!-- <b-modal size="lg" v-model="value" @click.prevent="closeShipmentModel" title="Confirmation" > -->
    <!-- <div role="document" style="">
      <div class="modal-content" > -->
        <!-- <div class="modal-headerfrm">
          <h4 class="modal-title">Route Shipment List</h4>
          <button type="button" class="close" @click.prevent="closeShipmentModel" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">×</span>
          </button>
        </div> -->
        <!-- <div class="modal-bodyfrm"> -->
          <!-- <div class="row" style="max-height: 400px; height: auto; overflow-y:auto"> -->
            <div class="col-md-12 routedetails" v-bind:class="{row: true, tableFixHead1: true}">
              <vue-element-loading spinner="line-scale" color="#FF6700" :active.sync="Shipmentloader"/>
              <table class="table-bordered table-hover tbl datatables" style="width:100%">
                <thead>
                <tr>
                  <th class="text-center tableheader" v-if="IsCheckbox" ><input type="checkbox" v-if="!checkboxDisabled" v-model="selectAllCheckbox" @click="selectAllItems($event)"></th>
                  <th class="text-center tableheader">AWB/ShippingID</th>
                  <th class="text-center tableheader" v-for="(cols,index) in columns" :key="index"> {{ cols.label }}</th>
                  <th class="text-center tableheader" v-if="IsEditSequenceNo">Edit SequenceNo</th>
                  <th class="text-center tableheader" v-if="IsRemoveShipment">Remove</th>
                  <th class="text-center tableheader" v-if="IsWithDraw">Withdraw Request</th>
                  <th class="text-center tableheader" v-if="IsDropDown">Select User's</th>
                  <th class="text-center tableheader" v-if="IsTakeAction">Action</th>
                  <th class="text-center tableheader" v-if="IsRaiseBtnAction">Action</th>
                  <th class="text-center tableheader" v-if="BatchID">Batch ID</th>
                  <th class="text-center tableheader" v-if="ShipmentsNum">No of Shipments</th>
                  <th class="text-center tableheader" v-if="ExchangeType">Exchange Type</th>
                  <th class="text-center tableheader" v-if="RemoveAllocatedShipment">Remove</th>
                </tr>
                </thead>
                <tbody>
                  <template v-if="showShipmentsList.length>0">
                    <tr v-for="(row,index) in showShipmentsList" :key="index">
                      <td class="text-center" v-if="IsCheckbox"><input type="checkbox" :value="row" v-model="selectedItemsOnChild" v-on:change="selectedItemdata($event,row)"></td>
                      <td class="text-center" v-if="row.requestid && row.shipmentcount && row.shipmentcount > 0">{{row.requestid}}<br> and <a class="clickable" style="cursor:pointer;" @click="showMultiShipPopup(row.requestid)"><u><font color="blue" style="text-decoration: underline;"> {{row.shipmentcount}} AWBs</font></u></a></td>
                      <td class="text-center" v-else>{{row[Object.keys(row).find(key => key.toLowerCase() === 'shippingid')]}}</td>
                      <td class="text-center" v-for="(colsData, index) in columns" :key="index"> {{ row[colsData.key] }}</td>
                      <td class="text-center" v-if="IsEditSequenceNo"><i @click="editSequenceNo(row.ShippingID)" style="cursor: pointer;font-size:14px" class="fa fa-edit" title="Edit OrderNo"></i></td>
                      <td class="text-center" v-if="IsRemoveShipment"><i @click="removeShipmentFromRoute(row.ShippingID,row.RouteId)" style="cursor: pointer;font-size:18px" class="fa fa-times-circle" title="Remove Shipment"></i></td>
                      <td class="text-center" v-if="IsWithDraw"><b-button class="btn btn-primary" @click="withDrawReq(row)" style="cursor: pointer;padding:4px" title="Withdraw" :disabled="row.status.toLowerCase() != 'unassigned' && row.status.toLowerCase() != 'pending'"><i class="fa fa-trash"></i> Withdraw </b-button></td>
                      <td class="text-center" v-if="IsDropDown && userList" :key="index">
                        <select name="option" @change="selectUser($event,row)" style="cursor: pointer;padding:10px; max-width: 150px; border-style:none; background-color: gainsboro;">
                          <option v-for="item in userList" :value="item.value" :key="item.value">{{ item.text }}</option>
                        </select>
                      </td>
                      <td class="text-center" v-if="IsTakeAction"><b-button :disabled="IsUserSelected" class="btn btn-primary" @click="takeAction(row)" style="cursor: pointer;padding:4px" title="Take Action"> Take Action </b-button></td>
                      <td class="text-center" v-if="IsRaiseBtnAction"><b-button class="btn btn-primary" @click="RaiseReqAction(row)" style="cursor: pointer;padding:4px" title="Raise Request"><i class=""></i> Raise Request</b-button></td>
                      <td class="text-center" v-if="BatchID && EnableHyperLink==true"><a class="clickable" style="cursor:pointer;" @click="printShipment(row.AssignBatchNo)"><u><font color="blue">{{row.AssignBatchNo}}</font></u></a></td>
                      <td class="text-center" v-if="BatchID && EnableHyperLink==false">{{row.AssignBatchNo}}</td>

                      <td class="text-center" v-if="ShipmentsNum"><a class="clickable" style="cursor:pointer;" @click="ExportCSV(row.shippingIDArray)"><u><font color="blue">{{row.NoOfShipments}}</font></u></a></td>
                      <td class="text-center" v-if="ExchangeType">{{ getExchangeType(row.ExchangeType) }}</td>
                      <td class="text-center" v-if="RemoveAllocatedShipment"><i @click="RemoveShipment(row.ShippingID)" style="cursor: pointer;font-size:18px" class="fa fa-times-circle" title="Remove Shipment"></i></td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr>
                      <td colspan="15" align="center" v-if="Shipmentloader != true">No record found</td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
           <!-- </div> -->
        <!--</div>
        <div class="modal-footerfrm" style="float:right">
          <button type="button" class="btn btn-danger" data-dismiss="modal" @click.prevent="closeShipmentModel()">close</button>
        </div>
      </div>
    </div> -->
  <!-- </b-modal> -->
</template>


<script>
import moment from 'moment'
import VueElementLoading from 'vue-element-loading';

export default{
  name: 'commonTableTemplate',
  components: {
    VueElementLoading
  },
  data: function() {
    return{
      // Shipmentloader: false,
      selectedItemsOnChild: [],
      selectAllCheckbox: false,
      IsUserSelected: false,
    }
  },
  props: {
    value: {
      type: Boolean,
      // required: true
    },

    Shipmentloader:{
      type: Boolean,
    },

    IsCheckbox:{
      type: Boolean,
    },
    checkboxDisabled:{
      type: Boolean,
    },
    IsRemoveShipment:{
      type: Boolean,
    },
    RemoveAllocatedShipment:{
      type: Boolean,
    },
    IsWithDraw:{
      type: Boolean
    },

    IsTakeAction:{
      type: Boolean
    },

    IsRaiseBtnAction:{
      type: Boolean
    },

    IsDropDown:{
      type: Boolean,
    },

    userList:{
      type: Array,
    },

    IsEditSequenceNo:{
      type: Boolean,
    },
    BatchID:{
      type: Boolean,
    },
    ShipmentsNum:{
      type: Boolean,
    },
    EnableHyperLink:{
      type: Boolean,
    },
    DisableHyperLink:{
      type: Boolean,
    },
    IsReload:{
      type: Boolean,
      // required: true
    },
    ExchangeType:{
      type: Boolean,
    },

    showShipmentsList: {
      type: Array,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
    // SrNo:{
    //   type: Boolean,
    // }
  },
  watch:{
    IsReload(val){
      if(val==true){
        this.selectedItemsOnChild = [];
        this.selectAllCheckbox= false;
        this.IsUserSelected = false;
      }
    }
  },
  methods: {
    closeShipmentModel(){
      this.$emit("input", !this.value);
    },
    removeShipmentFromRoute(shippingId,routeId){
      this.$emit("removeShipmentFromRoute", shippingId,routeId);
    },
    RemoveShipment(shippingId){
      this.$emit("RemoveShipment", shippingId);
    },
    editSequenceNo(shippingId){
      this.$emit("editSequenceNo", shippingId);
    },
    withDrawReq(row){
      this.$emit("withDrawReq", row);
    },
    RaiseReqAction(row){
      this.$emit("RaiseReqAction", row);
    },
    takeAction(row){
      this.$emit("takeAction", row);
    },
    showMultiShipPopup(reqId){
      this.$emit("showMultiShipPopup", reqId);
    },
    printShipment(AssignBatchNo){
      this.$emit("printShipment", AssignBatchNo);
    },
    ExportCSV(shippingIDArray){
      this.$emit("ExportCSV", shippingIDArray);
    },
    selectUser(row){
      this.$emit("selectUser", row);
    },
    // selectItems($event){
    //   this.$emit("selectItems", $event)
    // },
    selectAllItems(ev) {
      this.selectedItemsOnChild = [];
      if (ev.target.checked == true) {
        for (let i in this.showShipmentsList) {
          this.selectedItemsOnChild.push(this.showShipmentsList[i]);
        }
      }
      else{
        for (let i in this.showShipmentsList) {
          this.selectedItemsOnChild.pop(this.showShipmentsList[i]);
        }
      }

      if(this.showShipmentsList.length <= 1){
        for (let i in this.showShipmentsList) {
          this.selectedItemsOnChild.push(this.showShipmentsList[i]);
        }
        for (let i in this.showShipmentsList) {
          this.selectedItemsOnChild.pop(this.showShipmentsList[i]);
        }
      }
      this.selectedItemdata(ev);
    },

    selectedItemdata($event,row){
      this.IsUserSelected = false;
      if(this.selectedItemsOnChild.length == 0){
        this.selectAllCheckbox = false;
      }
      if(this.selectedItemsOnChild.length <= (this.showShipmentsList.length - 1)){
        this.selectAllCheckbox = false
      }
      if(this.selectedItemsOnChild.length == this.showShipmentsList.length){
        this.selectAllCheckbox = true
      }
      if(this.showShipmentsList.length <= 1){
        this.selectAllCheckbox = true;
        if(this.selectedItemsOnChild.length == 0){
          this.selectAllCheckbox = false
        }
      }
      if(this.selectedItemsOnChild.length > 0){
        this.IsUserSelected = true;
      }

      if($event.target.checked == false && typeof row != 'undefined'){
        if(row.Checker){
          delete row.Checker;
        }
      }
      this.$emit("selectedItemdata", this.selectedItemsOnChild)
    },

    selectUser(ev,row) {
      // console.log(ev.target.value);
      this.IsUserSelected = false;
      if(ev.target.value == 0){
        for (let i = 0; i < this.selectedItemsOnChild.length; i++) {
          if(this.selectedItemsOnChild[i].shippingid == row.shippingid){
            delete row.Checker;
            this.selectedItemsOnChild[i] = row;
          }
        }
      }
      else if (ev.target.value != 0) {
        let IsShipFlag = false;
        this.IsUserSelected = true;
        row.Checker = ev.target.value;
        for (let i = 0; i < this.selectedItemsOnChild.length; i++) {
          if(this.selectedItemsOnChild[i].shippingid == row.shippingid){
            IsShipFlag = true;
            this.selectedItemsOnChild[i] = row;
            break;
          }
        }
        if(IsShipFlag == false){
          this.selectedItemsOnChild.push(row);
        }
      }

      if(this.selectedItemsOnChild.length == 0){
        this.selectAllCheckbox = false;
        this.IsUserSelected = false;
      }
      if(this.selectedItemsOnChild.length <= (this.showShipmentsList.length - 1)){
        this.selectAllCheckbox = false
      }
      if(this.selectedItemsOnChild.length == this.showShipmentsList.length){
        this.selectAllCheckbox = true
      }
      this.$emit("selectUser", this.selectedItemsOnChild);
    },

    getExchangeType(exchangeType){
      let prexoType = null;
      if(exchangeType){
        /** REPLACEMENT type shipment */
        if (exchangeType.toLowerCase() == 'prep') {
          prexoType = 'REPLACEMENT';
        }

        /** EXCHANGE type shipment */
        if (exchangeType.toLowerCase() == 'pfex') {
          prexoType = 'EXCHANGE';
        }

        /** DYNAMIC type shipment */
        if (exchangeType.toLowerCase() == 'pdex') {
          prexoType = 'DYNAMIC EXCHANGE';
        }
      }

      return prexoType;
    }

  },
//   filters: {
//     moment: function(date) {
//       if (date == null || date == '')
//         return '--'
//       return moment(date).format('DD-MM-YYYY HH:mm:ss');
//     },
//   }
}

</script>

<style lang="css" scoped>

.tableFixHead1 { overflow-y: auto; height: auto; max-height: 400px }
.tableFixHead1 thead th { position: sticky; top: -1px }

.routedetails{
  padding-right: 0px;
  padding-left: 0px;
  margin-left: 0px;
  margin-right: 0px;
}

.btn.disabled, .btn:disabled{
    background-image: none;
    background-color: rgb(220, 228, 230);
    border-color: rgb(221, 234, 239);
    opacity: 1 !important;
    /* font-size: x-small; */
}
.btn.disabled:hover{
    text-decoration: line-through;
}
</style>



// WEBPACK FOOTER //
// src/views/components/common/table-template.vue?64f875e8